<script lang="ts" setup>
import { VProgressCircular } from 'vuetify/components';

const props = defineProps<{
  timeout?: string | number;
}>();
</script>

<template>
  <suspense :timeout="props.timeout">
    <slot />
    <template #fallback>
      <section class="loader__container" data-test-id="suspended-loader">
        <v-progress-circular indeterminate></v-progress-circular>
      </section>
    </template>
  </suspense>
</template>

<style>
.loader__container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
</style>
